import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

/**
 * Onglets de navigation entre les 3 vues du module Permissions.
 * Inclus dans chacune des 3 pages liste (permissions, resources, scopes).
 */
@Component({
  selector: 'app-permissions-tabs',
  imports: [RouterLink, RouterLinkActive],
  template: `
    <nav class="flex gap-1 border-b border-gray-200 dark:border-gray-800 page-header w-fit">
      <a
        routerLink="/permissions"
        routerLinkActive="border-b-2 border-brand-500 text-brand-700 dark:text-brand-400"
        [routerLinkActiveOptions]="{ exact: true }"
        class="-mb-px px-4 py-2.5 text-sm font-medium text-gray-500 transition hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-300"
      >
        Permissions
      </a>
      <a
        routerLink="/permissions/resources"
        routerLinkActive="border-b-2 border-brand-500 text-brand-700 dark:text-brand-400"
        [routerLinkActiveOptions]="{ exact: true }"
        class="-mb-px px-4 py-2.5 text-sm font-medium text-gray-500 transition hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-300"
      >
        Resources
      </a>
      <a
        routerLink="/permissions/scopes"
        [routerLinkActiveOptions]="{ exact: true }"
        routerLinkActive="border-b-2 border-brand-500 text-brand-700 dark:text-brand-400"
        class="-mb-px px-4 py-2.5 text-sm font-medium text-gray-500 transition hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-300"
      >
        Scopes
      </a>
    </nav>
  `,
})
export class PermissionsTabsComponent {}
